export const selectAssessmentList = (state) => state.assessmentlists;
